/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
    ARCHITECTURE_1oo1,
    ARCHITECTURE_1oo2,
    ARCHITECTURE_1oo3,
    ARCHITECTURE_2oo2,
    ARCHITECTURE_2oo3,
    ARCHITECTURE_2oo4,
    ARCHITECTURE_3oo3,
    YES,
    PFD,
    PFH,
} from "const"
import {
    SilArchitecture,
    SilCalculationType,
    YesNo,
} from "client/utils"

// "**" (double "*") is an equivalent of "Math.pow"
interface Isa_tr84_2022_PFD_Props {
    calcType: SilCalculationType
    architecture: SilArchitecture
    ti: number
    di: number
    mttr: number
    beta: number
    safeState: YesNo
    sd: number
    dd: number
    du: number
    dc: number
}

export const isa_tr84_2022_PFD = ({
    calcType,
    architecture,
    ti,
    di,
    mttr,
    beta,
    safeState,
    sd,
    dd,
    du,
    dc,
}: Isa_tr84_2022_PFD_Props) => {
    const d = safeState === YES
        ? sd + dd + du
        : dd + du

    if (architecture === ARCHITECTURE_1oo1) {
        if (calcType === PFH) return d
        if (calcType === PFD) return ((1 - dc) * d * ti) / 2 + (dc * d * di) / 2 + d * mttr
    }

    if (architecture === ARCHITECTURE_1oo2) {
        if (calcType === PFH) return 2 * (1 - beta) * d * (((1 - beta) * d * ti) / 2) + beta * d
        if (calcType === PFD) {
            return (
                ((1 - dc) * (1 - beta) * d * ti) / 2
                + (dc * (1 - beta) * d * di) / 2
                + (1 - beta) * d * mttr
            ) ** 2 + (
                ((1 - dc) * beta * d * ti) / 2
                + (dc * beta * d * di) / 2
                + beta * d * mttr
            )
        }
    }

    if (architecture === ARCHITECTURE_1oo3) {
        if (calcType === PFH) return 3 * (1 - beta) * d * (((1 - beta) * d * ti) / 2) ** 2 + beta * d
        if (calcType === PFD) {
            return (
                ((1 - dc) * (1 - beta) * d * ti) / 2
                + (dc * (1 - beta) * d * di) / 2
                + (1 - beta) * d * mttr
            ) ** 3 + (
                ((1 - dc) * beta * d * ti) / 2
                + (dc * beta * d * di) / 2
                + beta * d * mttr
            )
        }
    }

    if (architecture === ARCHITECTURE_2oo2) {
        if (calcType === PFH) return 2 * d
        if (calcType === PFD) return 2 * (((1 - dc) * d * ti) / 2 + (dc * d * di) / 2 + d * mttr)
    }

    if (architecture === ARCHITECTURE_2oo3) {
        if (calcType === PFH) return 6 * (1 - beta) * d * (((1 - beta) * d * ti) / 2) + beta * d
        if (calcType === PFD) {
            return 3 * (
                ((1 - dc) * (1 - beta) * d * ti) / 2
                + (dc * (1 - beta) * d * di) / 2
                + (1 - beta) * d * mttr
            ) ** 2 + (
                ((1 - dc) * beta * d * ti) / 2
                + (dc * beta * d * di) / 2
                + beta * d * mttr
            )
        }
    }

    if (architecture === ARCHITECTURE_2oo4) {
        if (calcType === PFH) return 12 * (1 - beta) * d * (((1 - beta) * d * ti) / 2) ** 2 + beta * d
        if (calcType === PFD) {
            return 4 * (
                ((1 - dc) * (1 - beta) * d * ti) / 2
                + (dc * (1 - beta) * d * di) / 2
                + (1 - beta) * d * mttr
            ) ** 3 + (
                ((1 - dc) * beta * d * ti) / 2
                + (dc * beta * d * di) / 2
                + beta * d * mttr
            )
        }
    }

    if (architecture === ARCHITECTURE_3oo3) {
        if (calcType === PFH) return 3 * du
        if (calcType === PFD) return 3 * (((1 - dc) * d * ti) / 2 + (dc * d * di) / 2 + d * mttr)
    }

    return null
}


interface Isa_tr84_2022_STR_Props {
    architecture: SilArchitecture
    ti: number
    mttr: number
    safeState: YesNo
    sd: number
    su: number
    dd: number
}

export const isa_tr84_2022_STR = ({
    architecture,
    ti,
    mttr,
    safeState,
    sd,
    su,
    dd,
}: Isa_tr84_2022_STR_Props) => {
    const sp = safeState === YES
        ? sd + su + dd
        : sd + su

    if (architecture === ARCHITECTURE_1oo1) {
        return sp
    }

    if (architecture === ARCHITECTURE_1oo2) {
        return 2 * sp
    }

    if (architecture === ARCHITECTURE_1oo3) {
        return 3 * sp
    }

    if (architecture === ARCHITECTURE_2oo2) {
        return 2 * sp * ((sp * ti) / 2 + sp * mttr)
    }

    if (architecture === ARCHITECTURE_2oo3) {
        return 6 * sp * ((sp * ti) / 2 + sp * mttr)
    }

    if (architecture === ARCHITECTURE_2oo4) {
        return 12 * sp * ((sp * ti) / 2 + sp * mttr)
    }

    if (architecture === ARCHITECTURE_3oo3) {
        return 3 * sp * ((sp * ti) / 2 + sp * mttr) ** 2
    }

    return null
}
